import {
  Button,
  Grid,
  GridSize,
  TextField,
  TextFieldProps,
} from "@material-ui/core";
import { Alert } from "@mui/material";
import { useEffect, useState } from "react";

export type TextFieldArrayProps = TextFieldProps & {
  values: (number | string)[];
  onArrayChange: (values: (number | string)[]) => void;
  alerts?: string[];
  md?: GridSize;
  lg?: GridSize;
};

export function TextFieldArray(props: TextFieldArrayProps) {
  const { values, alerts, onArrayChange, ...textFieldProps } = props;

  let { md, lg } = props;
  if (!md) md = 4;
  if (!lg) lg = 3;

  let typeNumber: boolean = false;
  if (textFieldProps.type && textFieldProps.type === "number")
    typeNumber = true;

  const [items, setItems] = useState(values);
  const [hasChanges, setHasChanges] = useState(false);

  const handleNewItem = () => {
    if (typeNumber) {
      const newValue = [...(items as number[]), 0];
      setItems(newValue);
    } else {
      const newValue = [...(items as string[]), ""];
      setItems(newValue);
    }
    setHasChanges(true);
  };

  const handleChangeItem = (item: string, index: number) => {
    const newArray = [...items];
    if (typeNumber) {
      const n = parseInt(item);
      newArray.splice(index, 1, n);
      setItems(newArray);
    } else {
      newArray.splice(index, 1, item);
      setItems(newArray);
    }
    setHasChanges(true);
  };

  const handleDeleteItem = (index: number) => {
    const newArray = [...items];
    newArray.splice(index, 1);
    setItems(newArray);
    setHasChanges(true);
  };

  useEffect(() => {
    if (hasChanges) {
      onArrayChange(items);
    }
  }, [items, hasChanges, onArrayChange]);

  if (items.length === 0) setItems([0]);

  return (
    <Grid container spacing={1}>
      {items.map((item, index) => (
        <Grid item md={md} lg={lg} key={`item_${index}`}>
          <TextField
            variant={"outlined"}
            style={{ width: "100%" }}
            value={item}
            onChange={(v) => handleChangeItem(v.target.value, index)}
            {...textFieldProps}
          ></TextField>
          <Button variant={"contained"} onClick={() => handleDeleteItem(index)}>
            Elimina
          </Button>{" "}
          &nbsp;
          <Button variant={"outlined"} onClick={handleNewItem}>
            Aggiungi
          </Button>
          {alerts && alerts[index] && (
            <Alert severity="error">{alerts[index]}</Alert>
          )}
        </Grid>
      ))}
    </Grid>
  );
}
